import React from 'react';
import { Navigate } from "react-router-dom";

import {
  ResponsiveHome,

  // Memorial pages
  ResponsiveAncestralTablet,
  ResponsiveProductInfo,
  ResponsiveServiceAdvantages,
  ResponsiveEventProcedure,
  ResponsiveMemorialPostBoardList,
  ResponsiveMemorialPostWriting,
  ResponsiveMemorialPostDetails,
  ResponsiveMemorialAlbumBoardList,
  ResponsiveMemorialAlbumWriting,
  ResponsiveMemorialAlbumArticleDetails,
  ResponsiveLetterToHeavenBoardList,
  ResponsiveLetterToHeavenWriting,
  ResponsiveLetterToHeavenPostDetails,
  ResponsiveManagementFeePaymentInquiry,
  ResponsiveManagementFeeInquiryResults,
  ResponsiveManagementSearch,

  // Sales pages
  ResponsiveSkyHallSpecialRoom,
  ResponsiveSkyHallPhoenixRoom,
  ResponsiveSkyHallVIP,
  ResponsiveStarHall,
  ResponsiveSunlightHall,
  ResponsiveSHall,
  ResponsiveOutdoorHall,

  // Auth & account
  ResponsiveLogin,
  ResponsiveSignup,
  ResponsiveSignupComplete,
  ResponsiveFindAccount,
  ResponsiveFindIdResult,
  ResponsivePasswordReset,
  ResponsiveEditInfo,

  // Others
  ResponsiveCyberMemorialSearch,
  ResponsiveDonate,
  ResponsiveDonateRegistration,
  ResponsiveFuneralInformationReligious,
  ResponsiveFuneralMethods,
  ResponsiveGeneralFuneralProcedures,
  ResponsiveFuneralInformationOther,
  ResponsiveOpeningMoving,

  // Announcement & News (non-responsive pages already)
  AnnouncementList,
  AnnouncementDetails,
  MemorialNewsList,
  MemorialNewsDetails,
  PrivacyPolicy,
  ServiceUseNotice,
  RefusalOfUnauthorized,
  TermsCondition,
  FAQCustomerCenter,
  ContactUs,
  InquiryDetails,
  ContactUsWriting,
  SecretPost,
  SaleInfo,
  MemorialGalleryListPC,
  GalleryDetailsPC,
  DirectionsPC,
  FacilityGuidePC,
  CEOGreetingPC,
  TakeLookPCFullView,
  IntroductionPC,
  TakeLookPCSkyHall,
  TakeLookPCSunlightHall,
  TakeLookPCSHall,
  TakeLookPCAHall,
  TakeLookPCSkyHallVIP,
  TakeLookPCStarlightHall,
  TakeLookPCFamilyHall,
  TakeLookPCOutdoorHall
} from "./ResponsiveWrappers";

const routes = [
  // Core
  { path: "/", element: <ResponsiveHome /> },
  { path: "/introduction-memorial", element: <IntroductionPC /> },
  { path: "/ceo-greeting", element: <CEOGreetingPC /> },
  { path: "/facilities", element: <FacilityGuidePC /> },
  { path: "/memorial-gallery-list", element: <MemorialGalleryListPC /> },
  { path: "/memorial-gallery-details/:id", element: <GalleryDetailsPC /> },
  { path: "/directions", element: <DirectionsPC /> },

  // Take a look / browse
  { path: "/overall-view", element: <TakeLookPCFullView /> },
  { path: "/sky-hall", element: <TakeLookPCSkyHall /> },
  { path: "/hall-vip", element: <TakeLookPCSkyHallVIP /> },
  { path: "/starlight-hall", element: <TakeLookPCStarlightHall /> },
  { path: "/sunshine-hall", element: <TakeLookPCSunlightHall /> },
  { path: "/s-hall", element: <TakeLookPCSHall /> },
  { path: "/a-hall", element: <TakeLookPCAHall /> },
  { path: "/family-hall", element: <TakeLookPCFamilyHall /> },
  { path: "/outdoor-hall", element: <TakeLookPCOutdoorHall /> },

  // Memorial sections
  { path: "/ancestral-tablet", element: <ResponsiveAncestralTablet /> },

  // Boards
  { path: "/memorial-post-board-list", element: <ResponsiveMemorialPostBoardList /> },
  { path: "/memorial-post-writing", element: <ResponsiveMemorialPostWriting /> },
  { path: "/memorial-post-details", element: <ResponsiveMemorialPostDetails /> },

  { path: "/memorial-album-board-list", element: <ResponsiveMemorialAlbumBoardList /> },
  { path: "/memorial-album-writing", element: <ResponsiveMemorialAlbumWriting /> },
  { path: "/memorial-album-article-details", element: <ResponsiveMemorialAlbumArticleDetails /> },

  { path: "/letter-to-heaven-board-list", element: <ResponsiveLetterToHeavenBoardList /> },
  { path: "/letter-to-heaven-writing", element: <ResponsiveLetterToHeavenWriting /> },
  { path: "/letter-to-heaven-post-details", element: <ResponsiveLetterToHeavenPostDetails /> },
  { path: "/letter-to-heaven-post-details/:id", element: <ResponsiveLetterToHeavenPostDetails /> },

  // Management fee
  { path: "/management-fee-payment-inquiry", element: <ResponsiveManagementFeePaymentInquiry /> },
  { path: "/management-fee-inquiry-results", element: <ResponsiveManagementFeeInquiryResults /> },
  { path: "/management-search", element: <ResponsiveManagementSearch /> },

  // Auth & account
  { path: "/login", element: <ResponsiveLogin /> },
  { path: "/signup", element: <ResponsiveSignup /> },
  { path: "/signup-complete", element: <ResponsiveSignupComplete /> },
  { path: "/find-account", element: <ResponsiveFindAccount /> },
  { path: "/find-id-result", element: <ResponsiveFindIdResult /> },
  { path: "/password-reset", element: <ResponsivePasswordReset /> },
  { path: "/edit-info", element: <ResponsiveEditInfo /> },

  // Search / Donate
  { path: "/cyber-memorial-search", element: <ResponsiveCyberMemorialSearch /> },
  { path: "/donate", element: <ResponsiveDonate /> },
  { path: "/donate-registration", element: <ResponsiveDonateRegistration /> },

  // Sales pages
  { path: "/sky-special-room", element: <ResponsiveSkyHallSpecialRoom /> },
  { path: "/sky-hall-phoenix-room", element: <ResponsiveSkyHallPhoenixRoom /> },
  { path: "/sky-hall-vip-sales", element: <ResponsiveSkyHallVIP /> },
  { path: "/star-hall-sales", element: <ResponsiveStarHall /> },
  { path: "/sunlight-hall-sales", element: <ResponsiveSunlightHall /> },
  { path: "/s-hall-sales", element: <ResponsiveSHall /> },
  { path: "/outdoor-hall-sales", element: <ResponsiveOutdoorHall /> },
  // Sales-Information
  { path: "/sales-info", element: <SaleInfo /> },

  // Funeral information
  { path: "/funeral-information-religious", element: <ResponsiveFuneralInformationReligious /> },
  { path: "/funeral-methods", element: <ResponsiveFuneralMethods /> },
  { path: "/general-funeral-procedures", element: <ResponsiveGeneralFuneralProcedures /> },
  { path: "/funeral-information-other", element: <ResponsiveFuneralInformationOther /> },
  { path: "/opening-relocation", element: <ResponsiveOpeningMoving /> },
  { path: "/mutual-assistance-product-info", element: <ResponsiveProductInfo /> },
  { path: "/service-advantages", element: <ResponsiveServiceAdvantages /> },
  { path: "/event-procedure", element: <ResponsiveEventProcedure /> },

  // Footer / Policy
  { path: "/privacy-policy", element: <PrivacyPolicy /> },
  { path: "/service-use-notice", element: <ServiceUseNotice /> },
  { path: "/refusal-of-unauthorized", element: <RefusalOfUnauthorized /> },
  { path: "/terms-condition", element: <TermsCondition /> },

  // Announcements & News
  { path: "/announcements", element: <AnnouncementList /> },
  { path: "/announcements/:id", element: <AnnouncementDetails /> },
  { path: "/memorial-news", element: <MemorialNewsList /> },
  { path: "/memorial-news/:id", element: <MemorialNewsDetails /> },
  { path: "/faq", element: <FAQCustomerCenter /> },
  { path: "/contact-us", element: <ContactUs /> },
  { path: "/inquiry-details/:id", element: <InquiryDetails /> },
  { path: "/contact-us-writing/:id?", element: <ContactUsWriting /> },
  { path: "/contact-secret-post/:id", element: <SecretPost /> },

  // Fallback
  { path: "*", element: <Navigate to="/service-use-notice" replace /> },
];

export default routes;
